import { useStoreId } from '@/hooks';
import { SingleCartButton } from '@/components/Cart';
import { ActiveCartsButton } from '@/components/ActiveCarts';

const CartButton = () => {
  const storeId = useStoreId();

  // In a single store context
  if (storeId) {
    return <SingleCartButton />;
  }

  return <ActiveCartsButton />;
};

export default CartButton;
